
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Instagram Ads vs Facebook Ads : Quel choix pour votre marque ?",
    description:
      "Instagram Ads ou Facebook Ads ? Découvrez les différences entre ces plateformes publicitaires et comment choisir la meilleure pour vos objectifs avec ALEO.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
